import * as actionType from "./assetsCategoryActions";
import { ApiGateWay } from "../../../ApiGateWay/ApiGateWay";
import { Config } from "../../../config/config";
import Cookie from "js-cookie";
import LZString from "lz-string";
const config = JSON.parse(Config);
const apiInterface = config["api1"];
const apiInterface4 = config["api4"];
const initialState = {
  message: "",
  modalOpen: false,
  loading: false,
  apiStatus: false,
};
export const GetAssetsCategoryLIst = (data) => ({
  type: actionType.GET_ASSETS_CATEGORY_LIST,
  payload: data,
});

export const APIStart = (data) => ({
  type: actionType.ASSETS_CATEGORY_API_START,
  payload: data,
});
export const addSubCat = (data) => ({
  type: actionType.ADD_SUB_CAT,
  payload: data,
});
export const subCatList = (data) => ({
  type: actionType.SUB_CAT_LIST,
  payload: data,
});
export const subCatEdit = (data) => ({
  type: actionType.SUB_CAT_EDIT,
  payload: data,
});
export const getSelectedAssetCategory = (data) => ({
  type: actionType.GET_SELECTED_ASSETS_CATEGORY_LIST,
  payload: data,
});

export const mainCatgeoryForEdit = (data) => ({
  type: actionType.MAIN_CATEGORY_EDIT,
  payload: data,
});

export const subCatgeoryForEdit = (data) => ({
  type: actionType.SUB_CATEGORY_EDIT,
  payload: data,
});

export const doGetAssetsCategoryList = () => async (dispatch) => {
  const jsonData = Cookie.get("currentUser");
  let decompressedData = LZString.decompressFromBase64(jsonData);
  decompressedData =
    decompressedData == "\x00\x00\x00" ? jsonData : decompressedData;
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.GetData(
    apiInterface + "/AssetCategories/loadallassetcategoriesinfo"
  )
    .then((result) => {
      initialState.loading = false;
      if (result[0]?.Table1[0]?.status_code == "000") {
        initialState.message = result[0]?.Table1[2]?.status_msg;
        const AssetMainCategory = result[1].Table2;
        const AssetSubCategory = result[2].Table3;
        const AllAssetCategoryList = result[3].Table4;
        AssetSubCategory.unshift({ id: 0, name: "OTHER" });
        initialState.apiStatus = true;
        dispatch(APIStart(initialState));
        dispatch(
          GetAssetsCategoryLIst({
            AssetMainCategory,
            AssetSubCategory,
            AllAssetCategoryList,
          })
        );
        // dispatch(getSelectedAssetCategory(AssetsList[0]))
      } else {
        initialState.apiStatus = false;
        initialState.loading = false;
        initialState.modalOpen = true;
        initialState.message = result[1]?.Table1[2]?.status_msg;
        dispatch(APIStart(initialState));
        // console.log(response, 'response1')
      }
    })
    .catch((e) => {
      initialState.apiStatus = false;
      initialState.loading = false;
      initialState.modalOpen = true;
      initialState.message =
        "Something went wrong please try again after sometime";
      dispatch(APIStart(initialState));
      // dispatch(apiCallStatus(initialState))
    });
};

export const SaveMainCategoryInfo = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.newSimplePost(apiInterface4 + "/api/saveMainCategory", values)
    .then((result) => {
      initialState.loading = false;
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const UpdateMainCategoryInfo = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.newSimplePut(apiInterface4 + "/api/updateMainCategory", values)
    .then((result) => {
      initialState.loading = false;
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const SaveSubCategoryInfo = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.newSimplePost(apiInterface4 + "/api/saveSubCategory", values)
    .then((result) => {
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const UpdateSubCategoryInfo = (values) => async (dispatch) => {
  initialState.loading = true;
  dispatch(APIStart(initialState));
  ApiGateWay.SimplePut(apiInterface4 + "/api/updateSubCategory", values)
    .then((result) => {
      if (!!result.errorMessage) {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.errorMessage,
          dispatch,
          APIStart,
          initialState
        );
      } else {
        ApiGateWay.updateStateForApi(
          false,
          true,
          true,
          result.status,
          dispatch,
          APIStart,
          initialState
        );
      }
    })
    .catch((e) => {
      ApiGateWay.updateStateForApi(
        false,
        true,
        false,
        e.error,
        dispatch,
        APIStart,
        initialState
      );
    });
};

export const checkIfNameNCatgeoryEmpty = (name, maintenanceMainCategoryId) => {
  return !name || !maintenanceMainCategoryId;
};

export const returnNullForEmpty = (field) => {
  return field == "" ? null : field;
};

export const isActiveTrue = (field) => {
  return field == 1 || field === "" ? true : false;
};
